export default __webpack_public_path__ + "static/media/back.01db177c.svg";